import * as S from "./ModalConfirm.style";
import { Buttons } from "@/components/atoms/Buttons";
import { ModalProps, Modals } from "..";

interface ModalConfirmProps extends ModalProps {
  onConfirm: () => void;
}

export const ModalConfirm = ({
  onConfirm,
  setModalShow,
}: ModalConfirmProps) => {
  return (
    <Modals
      setModalShow={setModalShow}
      modalButtons={
        <>
          <Buttons
            type="button"
            size="lg"
            layout="text"
            color="primary100"
            label="취소"
            onClick={() => setModalShow(false)}
          />
          <Buttons
            type="button"
            size="lg"
            layout="text"
            color="primary100"
            label="등록"
            onClick={onConfirm}
          />
        </>
      }
    >
      <S.ModalConfirmContent>
        문의를 등록하시겠습니까?
        <span>* 등록된 문의는 수정 및 삭제가 불가합니다.</span>
      </S.ModalConfirmContent>
    </Modals>
  );
};
